import { NavLink, Outlet } from "react-router-dom";
import { Car } from "lucide-react";
import { getPillarById } from "@/data/pillars";

export default function TravelLayout() {
  const work = getPillarById("work");
  const tabs = [
    { to: "/pillar/work/travel", label: "Registration", end: true },
    { to: "/pillar/work/travel/settings", label: "Settings" },
  ];

  return (
    <div className="px-5 md:px-8 py-8 max-w-[1500px]">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-3 h-3 rounded-full" style={{ backgroundColor: work.color }} />
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">Work</span>
      </div>
      <h1 className="font-serif text-3xl md:text-4xl text-foreground flex items-center gap-3 mb-6">
        <Car className="w-7 h-7 text-muted-foreground" strokeWidth={1.5} /> Travel
      </h1>

      <nav className="flex gap-1 overflow-x-auto quiet-scroll border-b border-border mb-8" data-testid="travel-tabs">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`travel-tab-${t.label.toLowerCase()}`}
            className={({ isActive }) =>
              `px-3.5 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors duration-200 ${
                isActive
                  ? "border-foreground text-foreground font-medium"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
